<template>
  <div class="p-6">
    <div class="mb-4 flex justify-between items-center">
      <h1 class="text-2xl font-semibold">{{ agent.id ? '编辑' : '新建' }} Agent</h1>
      <div class="flex gap-2">
        <el-button @click="router.visit('/admin/aigc/agents')">返回</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </div>

    <el-form 
      ref="formRef"
      :model="form"
      class="max-w-3xl"
      label-position="top"
    >
      <el-form-item prop="type" label="类型">
        <el-input v-model="form.type" placeholder="请输入类型" />
      </el-form-item>

      <el-form-item prop="name" label="名称">
        <el-input v-model="form.name" placeholder="请输入名称" />
      </el-form-item>

      <el-form-item prop="gender" label="性别">
        <el-select v-model="form.gender" placeholder="请选择性别" class="w-full">
          <el-option label="男" value="male" />
          <el-option label="女" value="female" />
        </el-select>
      </el-form-item>

      <el-form-item prop="description" label="描述">
        <el-input v-model="form.description" type="textarea" placeholder="请输入描述" />
      </el-form-item>

      <el-form-item prop="voice_id" label="语音ID">
        <el-input v-model="form.voice_id" placeholder="请输入语音ID" />
      </el-form-item>

      <el-form-item prop="greeting" label="问候语">
        <el-input v-model="form.greeting" type="textarea" placeholder="请输入问候语" />
      </el-form-item>

      <el-form-item prop="provider" label="提供商">
        <el-input v-model="form.provider" placeholder="请输入提供商" />
      </el-form-item>

      <el-form-item prop="model" label="模型">
        <el-input v-model="form.model" placeholder="请输入模型" />
      </el-form-item>

      <el-form-item prop="prompt" label="提示词">
        <el-input v-model="form.prompt" type="textarea" placeholder="请输入提示词" />
      </el-form-item>
    </el-form>
  </div>
</template> 

<script setup>
import { ElMessage } from 'element-plus'
const props = defineProps({
  row: {
    type: Object,
    required: true
  }
})

const form = ref({
  type: '',
  name: '',
  gender: '',
  description: '',
  voice_id: '',
  greeting: '',
  provider: '',
  model: '',
  prompt: ''
})

const formRef = ref()

onMounted(() => {
  if (props.row) {
    Object.assign(form.value, props.row)
  }
})

const handleSubmit = async () => {
  try {
    const { data } = await router.post('/admin/aigc/agents/upsert', {
      agent: form.value
    })

    if (data.success) {
      ElMessage.success('保存成功')
      router.visit('/admin/aigc/agents')
    } else {
      ElMessage.error(data.errors.join(', '))
    }
  } catch (error) {
    ElMessage.error('保存失败')
  }
}
</script>

<script>
export default { layout: Admin }
</script>
